module.exports = __webpack_public_path__ + "static/media/soreness.2f2ccaa6.svg";